import {createSelector} from "@ngrx/store";
import {INotificationState} from "@ispm/dashboard/notification/store/notification.reducer";

export const selectNotification = (state: INotificationState) => state;
export const getNotification = createSelector(selectNotification, (state) => state.description);

